'use client';
import React, { useState } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { SUPPORTED_LANGUAGES } from '@/lib/i18n';
import { ChevronDown } from 'lucide-react';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);

  const current = SUPPORTED_LANGUAGES?.find((l) => l?.code === language) ?? SUPPORTED_LANGUAGES?.[0];

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-600 text-muted-foreground hover:text-foreground hover:bg-muted/40 transition-all"
        aria-label="Change language"
      >
        <span>{current?.flag}</span>
        <span className="hidden sm:inline">{current?.label}</span>
        <ChevronDown size={12} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 z-50 min-w-[140px] rounded-xl bg-card border border-border shadow-xl overflow-hidden">
            {SUPPORTED_LANGUAGES?.map((lang) => (
              <button
                key={lang?.code}
                onClick={() => { setLanguage(lang?.code); setOpen(false); }}
                className={`w-full flex items-center gap-2.5 px-4 py-2.5 text-sm transition-colors ${
                  language === lang?.code
                    ? 'bg-primary/10 text-primary font-600' :'text-muted-foreground hover:text-foreground hover:bg-muted/40'
                }`}
              >
                <span>{lang?.flag}</span>
                <span>{lang?.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
